import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { getFestival } from '../services/api';

const FestivalBanner = () => {
  const [festival, setFestival] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getFestival();
        if (res.data?.active) setFestival(res.data);
      } catch {}
    };
    fetch();
  }, []);

  if (!festival || !festival.active || dismissed) return null;

  const colors = festival.colors || ['#2E3A6F', '#4a5a9f', '#FFD700'];

  return (
    <div
      className="relative overflow-hidden"
      style={{ background: `linear-gradient(135deg, ${colors[0]}, ${colors[1]}, ${colors[2]})` }}
      data-testid="festival-banner"
    >
      {/* Animated particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1.5 h-1.5 bg-white/30 rounded-full animate-float"
            style={{
              left: `${(i * 8.3) % 100}%`,
              animationDelay: `${i * 0.3}s`,
              animationDuration: `${3 + (i % 3)}s`
            }}
          />
        ))}
      </div>

      <div className="container mx-auto px-4 py-2.5 flex items-center justify-center relative">
        <p className="text-white text-sm font-medium text-center tracking-wide">
          {festival.banner_text}
        </p>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-4 text-white/60 hover:text-white transition-colors"
          aria-label="Dismiss"
        >
          <X size={16} />
        </button>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(30px); opacity: 0; }
          50% { transform: translateY(-10px); opacity: 1; }
        }
        .animate-float { animation: float 3s ease-in-out infinite; }
      `}</style>
    </div>
  );
};

export default FestivalBanner;
